import { GetUsersParams } from "@bvhi/backend-api/apis/model/getUsersParams";
import { StatusParameter } from "@bvhi/backend-api/apis/model/statusParameter";
import { UserSortParameter } from "@bvhi/backend-api/apis/model/userSortParameter";
import { UsersSortByParam } from "@bvhi/backend-api/apis/model/usersSortByParam";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { UsersListView } from "../../../views/app/user/users/list/users-list-view";

export const Route = createFileRoute("/_main/app/users/")({
  validateSearch: (search: Record<string, unknown>): GetUsersParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as UserSortParameter) || [UsersSortByParam.LAST_NAME_ASC],
      status: (search?.status as StatusParameter) || ["ACTIVE", "INACTIVE"],
    };
  },
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: UsersListView }) }),
});
